import * as o from "react";
import r from "../lib/IconBase.es.js";
import s from "../defs/Stethoscope.es.js";
const e = o.forwardRef((t, c) => /* @__PURE__ */ o.createElement(r, { ref: c, ...t, weights: s }));
e.displayName = "StethoscopeIcon";
const p = e;
export {
  p as Stethoscope,
  e as StethoscopeIcon
};
